// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.day-picker-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}

.day-picker-title {
    font-size: 20px;
    margin-bottom: 20px;
}

.day-picker-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
}

.day-picker-box {
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    padding: 10px;
    transition: background-color 0.2s ease;
}

.day-picker-box:hover {
    background-color: #f5f5f5;
}

.day-picker-box.selected {
    background-color: #3498ff;
    color: #fff;
}

.day-picker-day {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}

.day-picker-details {
    font-size: 14px;
    line-height: 1.5;
}

.day-picker-time {
    margin-bottom: 5px;
}

.day-picker-project {
    margin-bottom: 5px;
}

.day-picker-location {
    color: #999;
}

.day-picker-selected {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    text-align: center;
}

.day-picker-selected-day {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.day-picker-selected-details {
    margin-top: 20px;
    font-size: 18px;
    line-height: 1.5;
}

.day-picker-selected-time {
    margin-bottom: 10px;
}

.day-picker-selected-project {
    margin-bottom: 10px;
}

.day-picker-selected-location {
    color: #999;
}

/* Responsive Styles */

@media (max-width: 768px) {
    .day-picker-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .day-picker-grid {
        grid-template-columns: repeat(1, 1fr);
    }

    .day-picker-box {
        font-size: 16px;
        padding: 8px;
    }

    .day-picker-day {
        font-size: 16px;
    }

    .day-picker-details {
        font-size: 12px;
    }

    .day-picker-selected-day {
        font-size: 20px;
    }

    .day-picker-selected-details {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DayPicker.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,sBAAsB;;AAEtB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".day-picker-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.day-picker-title {\n    font-size: 20px;\n    margin-bottom: 20px;\n}\n\n.day-picker-grid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 10px;\n}\n\n.day-picker-box {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n    padding: 10px;\n    transition: background-color 0.2s ease;\n}\n\n.day-picker-box:hover {\n    background-color: #f5f5f5;\n}\n\n.day-picker-box.selected {\n    background-color: #3498ff;\n    color: #fff;\n}\n\n.day-picker-day {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.day-picker-details {\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.day-picker-time {\n    margin-bottom: 5px;\n}\n\n.day-picker-project {\n    margin-bottom: 5px;\n}\n\n.day-picker-location {\n    color: #999;\n}\n\n.day-picker-selected {\n    margin-top: 20px;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    text-align: center;\n}\n\n.day-picker-selected-day {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\n.day-picker-selected-details {\n    margin-top: 20px;\n    font-size: 18px;\n    line-height: 1.5;\n}\n\n.day-picker-selected-time {\n    margin-bottom: 10px;\n}\n\n.day-picker-selected-project {\n    margin-bottom: 10px;\n}\n\n.day-picker-selected-location {\n    color: #999;\n}\n\n/* Responsive Styles */\n\n@media (max-width: 768px) {\n    .day-picker-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .day-picker-grid {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .day-picker-box {\n        font-size: 16px;\n        padding: 8px;\n    }\n\n    .day-picker-day {\n        font-size: 16px;\n    }\n\n    .day-picker-details {\n        font-size: 12px;\n    }\n\n    .day-picker-selected-day {\n        font-size: 20px;\n    }\n\n    .day-picker-selected-details {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
